<!--
  TODO: Extract all the auto-save stuff into its own component.
  * Status from template
  * Save methods from script

  Would prefer this component to focus on showing a prompt and a text editor.
  Let something else monitor for changes and handle the autosave. Unless this
  is going to be the only place we need auto-save.
-->

<template>
  <section>
    <p v-html="model.question.promptHtml"></p>
    <template v-if="respondable">
      <redactor class="redactor--expand" placeholder="Begin typing..." :value="model.response" @input="updateValue"></redactor>
      <p class="status">{{ status }}</p>
    </template>
    <template v-else>
      <div class="response" >
        <annotator :config="{}" :inject="userAssignment.teacherAnnotations" :on="false">
          <div v-html="model.annotatedResponse"></div>
        </annotator>
      </div>
    </template>
  </section>
</template>

<script>

  import Annotator from '@/components/Annotator'

  const statusMessages = {
    idle: '',
    saving: 'Saving changes...',
    saved: 'Saved',
    error: 'Unable to save changes. Retrying...'
  }

  let save = function() {
    let vm = this
    vm.model.DSSave()
      .then(() => vm.status = statusMessages.saved)
      .catch(() => {
        vm.status = statusMessages.error
        _.delay(vm.startSaving, 5000)
      })
  }

  export default {
    name: 'WriteResponse',
    props: {
      model: {
        type: Object,
        required: true
      },
      respondable: {
        type: Boolean,
        default: false
      }
    },
    components: { Annotator },
    data () {
      return {
        status: statusMessages.idle,
        debouncedSave: _.debounce(_.bind(save, this), 5000),
        userAssignment: this.$store.get('userAssignments', this.model.userAssignmentId)
      }
    },
    methods: {
      updateValue (newValue) {
        this.model.response = newValue
        this.startSaving()
      },
      startSaving () {
        this.status = statusMessages.saving
        this.debouncedSave()
      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .status {
    @include font-size(small);
  }

  .response {
    font-weight:300;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/write-response.vue